<div class="create-subscription-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Create New Subscription</h1>
        <p>Create a new subscription for an agent</p>
      </div>
      <a routerLink="/subscriptions" class="back-btn" (click)="onCancel()">
        <i class="fas fa-arrow-left"></i> Back to Subscriptions
      </a>
    </div>
  </div>

  <div class="form-container">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
      </div>
      <p>Loading agents and zones...</p>
    </div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" (click)="successMessage = ''"></button>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{ errorMessage }}
      <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    </div>

    <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading">
      <div class="form-section">
        <h3>Basic Information</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="agentId">Agent *</label>
            <select 
              id="agentId" 
              formControlName="agentId" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('agentId')">
              <option value="">Select Agent</option>
              <option *ngFor="let agent of (agents$ | async)" [value]="agent.agentId">
                {{ agent.name }} ({{ agent.phoneNumber }})
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('agentId')">
              {{ getFieldError('agentId') }}
            </div>
          </div>

          <div class="form-group">
            <label for="zoneId">Zone *</label>
            <select 
              id="zoneId" 
              formControlName="zoneId" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('zoneId')">
              <option value="">Select Zone</option>
              <option *ngFor="let zone of (zones$ | async)" [value]="zone.id">
                {{ zone.name }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('zoneId')">
              {{ getFieldError('zoneId') }}
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="type">Plan Type *</label>
            <select 
              id="type" 
              formControlName="type" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('type')">
              <option value="">Select Plan Type</option>
              <option *ngFor="let plan of planTypes" [value]="plan.value">
                {{ plan.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
              {{ getFieldError('type') }}
            </div>
          </div>

          <div class="form-group">
            <label for="cadence">Cadence *</label>
            <select 
              id="cadence" 
              formControlName="cadence" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('cadence')">
              <option value="">Select Cadence</option>
              <option *ngFor="let cadence of cadenceOptions" [value]="cadence.value">
                {{ cadence.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('cadence')">
              {{ getFieldError('cadence') }}
            </div>
            <small class="form-text text-muted">
              The subscription amount will be calculated automatically based on plan type and cadence
            </small>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3>Payment Details</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="paymentMethod">Payment Method *</label>
            <select 
              id="paymentMethod" 
              formControlName="paymentMethod" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('paymentMethod')">
              <option value="">Select Payment Method</option>
              <option *ngFor="let method of paymentMethods" [value]="method.value">
                {{ method.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('paymentMethod')">
              {{ getFieldError('paymentMethod') }}
            </div>
          </div>

          <div class="form-group">
            <label for="paymentReference">Payment Reference</label>
            <input 
              type="text" 
              id="paymentReference" 
              formControlName="paymentReference" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('paymentReference')"
              placeholder="Enter payment reference (e.g., transaction ID, receipt number)">
            <div class="invalid-feedback" *ngIf="isFieldInvalid('paymentReference')">
              {{ getFieldError('paymentReference') }}
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="notes">Notes</label>
            <textarea 
              id="notes" 
              formControlName="notes" 
              class="form-control"
              [class.is-invalid]="isFieldInvalid('notes')"
              rows="3"
              placeholder="Enter any additional notes"></textarea>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('notes')">
              {{ getFieldError('notes') }}
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="onCancel()"
          [disabled]="isSubmitting">
          Cancel
        </button>
        <button 
          type="submit" 
          class="btn btn-primary" 
          [disabled]="isSubmitting || subscriptionForm.invalid">
          <app-loading 
            *ngIf="isSubmitting" 
            [isLoading]="true"
            size="small"
            color="white"
            [message]="''">
          </app-loading>
          <span *ngIf="!isSubmitting">Create Subscription</span>
          <span *ngIf="isSubmitting" class="ms-2">Creating...</span>
        </button>
      </div>
    </form>
  </div>
</div>
